import axios from 'axios';
import { useEffect } from 'react';
import { url, databricksurl, isLocalEnv } from '../../service/config';
import { useLocation } from 'react-router-dom';
import {
	usePepwiseAuthController,
	setAuthenticated,
	setAuthToken,
	setAuthType,
	setRole,
	setCapabilities
} from 'Context/contexts/AuthContext';
import { getDecodedToken, setCookie } from 'service/service';
import { useRedirectLogin } from 'hooks/useRedirectHooks';

const MOCK_ROLES = [{ name: 'D&AI Executive', capabilities: ['Data Estate', 'Data Ops', 'Fin Ops'] }];

function buildMockJwt() {
	const header = btoa(JSON.stringify({ alg: 'none', typ: 'JWT' }));
	const payload = btoa(JSON.stringify({
		email: 'dev.user@pepsico.com',
		firstName: 'Dev',
		lastName: 'User',
		displayName: 'Dev User',
		role: MOCK_ROLES,
		sector: { name: 'All' },
		exp: Math.floor(Date.now() / 1000) + 86400,
	}));
	return `${header}.${payload}.mock-signature`;
}

export default function LoginScreen() {
	const location = useLocation();
	const { redirectAfterLogin } = useRedirectLogin();
	const [, dispatch] = usePepwiseAuthController();

	const extractCapabilities = (roles: any[] = []): string[] => {
	return roles.reduce((acc: string[], role: any) => {
		(role.capabilities || []).forEach((cap: string) => {
		if (!acc.includes(cap)) acc.push(cap);
		});
		return acc;
	}, []);
	};

	const extractRoleNames = (roles: any): string[] => {
	if (Array.isArray(roles)) return roles.map((r) => r.name);
	return roles ? [roles.name] : [];
	};

	const applyAuthState = (
	dispatch: any,
	auth: any,
	roleNames: string[],
	capabilities: string[]
	) => {
	setAuthType(dispatch, 'sso');
	setAuthToken(dispatch, auth);
	setAuthenticated(dispatch, true);
	setRole(dispatch, roleNames);
	setCapabilities(dispatch, capabilities);
	};

	useEffect(() => {
	// if (isLocalEnv) {
	// 	const mockJwt = buildMockJwt();
	// 	setCookie('id_token', mockJwt);
	// 	const capabilities = extractCapabilities(MOCK_ROLES);
	// 	const roleNames = extractRoleNames(MOCK_ROLES);
	// 	applyAuthState(dispatch, { role: MOCK_ROLES }, roleNames, capabilities);
	// 	setAuthenticated(dispatch, true);
	// 	redirectAfterLogin();
	// 	return;
	// }

	axios
		.get(`${url}/user/me`)
		.then((response) => {
		if (response.status === 302) {
			const redirectUrl = response.headers.location;
			if (redirectUrl) {
			window.location.href = redirectUrl;
			} else {
			console.error('Error in response header');
			}
			return;
		}

		if (response.status !== 200) return;

		const { success, data } = response.data;
		if (!success) {
			window.location.href = '/sso/login';
			return;
		}

		const auth = getDecodedToken();
		if (!auth) return;

		const capabilities = extractCapabilities(auth.role);
		const roleNames = extractRoleNames(auth.role);

		applyAuthState(dispatch, auth, roleNames, capabilities);

		setAuthenticated(dispatch, true);
		sessionStorage.setItem('auth', JSON.stringify(data));

		axios.get(`${databricksurl}`).then(() => {
			console.log('Databricks Call completed');
		});

		redirectAfterLogin();
		})
		.catch((error) => {
		console.error('Login error:', error);
		});
	}, [location]);

	return null;
}
